import history from '~/lib/history';

export function useRedirect() {
  const redirect = (to: string) => {
    return history.push(to);
  };
  return { redirect };
}
